import Immutable from 'immutable';
import { createSelector } from 'reselect';

const bibsById = state => state.getIn(['entities', 'bibs'], Immutable.Map());

export const getBibsByMetadataId = createSelector(
  [bibsById],
  (bibs) => bibs
);

export default {
  getBibsByMetadataId
};



// WEBPACK FOOTER //
// ./app/selectors/BibSelector.js